import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMeetupComponent } from './simple-icons-meetup.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMeetupComponent ],
    exports:      [ SimpleIconsMeetupComponent ],
    bootstrap:    []
})
export class SimpleIconsMeetupModule {}
